// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FileUploadSvg from '@rsuite/icon-font/lib/action/FileUpload';
var FileUpload = createSvgIcon({
  as: FileUploadSvg,
  ariaLabel: 'file upload',
  category: 'action',
  displayName: 'FileUpload'
});
export default FileUpload;